export default __webpack_public_path__ + "static/media/C0000.28511044.png";